module.exports = __webpack_public_path__ + "images/xl-guangxi.jpg?24367af64ea36e1acde11184b0b1d835";


//////////////////
// WEBPACK FOOTER
// ./src/images/active/xl-guangxi.jpg
// module id = 207
// module chunks = 1